import { useMemo } from 'react';

const MS_PER_DAY = 1000 * 60 * 60 * 24;
const EXPIRY_WARN_DAYS = 7;

/**
 * SubscriptionBadge
 *
 * Props:
 *   active      {boolean}       — whether subscription is active
 *   expiresAtMs {number|null}   — Unix ms expiry, or null for open-ended
 */
export default function SubscriptionBadge({ active, expiresAtMs }) {
  const { cls, label } = useMemo(() => {
    if (!active) {
      return { cls: 'badge badge-danger', label: 'Inactive' };
    }
    if (expiresAtMs != null) {
      const daysLeft = Math.ceil((expiresAtMs - Date.now()) / MS_PER_DAY);
      if (daysLeft <= 0) {
        return { cls: 'badge badge-danger', label: 'Expired' };
      }
      if (daysLeft <= EXPIRY_WARN_DAYS) {
        return { cls: 'badge badge-warning', label: `Expiring in ${daysLeft}d` };
      }
    }
    return { cls: 'badge badge-success', label: 'Active' };
  }, [active, expiresAtMs]);

  return <span className={cls}>{label}</span>;
}
